module.exports = __webpack_public_path__ + "static/img/bg_4.b0a7df4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_4.jpg
// module id = k6BZ
// module chunks = 1